module.exports = __webpack_public_path__ + "img/IEMLCMBX.25b24c6b.png";